import { Dialogue, type DialogueProps } from './Dialogue.js';
import { useIsMobile } from '../hooks/useIsMobile.js';

export type SheetProps = Omit<DialogueProps, 'forme' | 'nu'>;

/**
 * Une feuille ancrée en bas sur un téléphone (`.dialogue-feuille`, qui suit le clavier d'iOS),
 * un dialogue sur un bureau : le même contenu, la forme que l'écran appelle. `anchor` ne vaut
 * que pour le bureau.
 */
export function Sheet(props: SheetProps): React.ReactElement | null {
  const isMobile = useIsMobile();
  return isMobile ? <Dialogue {...props} forme="feuille" /> : <Dialogue {...props} />;
}
